import Event from './Event.js';

export default class Structured extends Event {
  setData(category, action, label, property, value) {
    this._pushEventData(
      'trackStructEvent',
      category,
      action,
      label || null,
      property || null,
      value || null
    );
  }
}
